import {IS_CLIENT_SIDE} from '../../../common/shared/utils/constants';
import {EmoticonItem} from '../type';

/**
 * callback return값을 true로 설정하면 이모티콘 선택 후에도 창이 닫히지 않습니다.
 */
export async function setSelectEmoticonCallback(
  callback: (selectedEmoticon: EmoticonItem) => boolean | void
) {
  if (!IS_CLIENT_SIDE || !window?.Kakao?.Emoticon) {
    return;
  }
  // 해당 값이 없으면 초기화되지 않은 상황이므로 초기화를 진행해줍니다.
  if (!window.Kakao.Emoticon.emoticon) {
    window.Kakao.Emoticon.init({
      useAppKey: true,
    });
    await new Promise<void>(res =>
      window.setTimeout(() => {
        res();
      }, 500)
    );
  }
  window.Kakao.Emoticon.emoticon.options.callback.selectEmoticon = callback;
}
